import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

const withTimeOut = (ComposedClass) => {
    return class extends Component {
        constructor(props) {
            super(props);
            this.warnTimeout = null;
            this.refreshTimeout = null;
            this.durationInterval = null;
            this.state = {
                endTime: 0,
                idleTimeInMinutes: 0,
                warningTimeinMinutes: 0,
                warningTime: 0,
                open: false,
                duration: 0
            };
        }

        componentDidMount() {
            this.events = [
                'load',
                'mousedown',
                'click',
                'scroll',
                'keypress'
            ];

            for (var i in this.events) {
                window.addEventListener(this.events[i], this.resetTimeout);
            }

            this.getSessionTimeOut();
        }

        getSessionTimeOut = () => {
            axios.get('session')
                .then(response => {
                    const { idleTimeOutInMinutes, warningTimeoutInMinutes } = response.data;
                    this.setSession(idleTimeOutInMinutes, warningTimeoutInMinutes);
                    this.setTimeout();
                });
        }

        handleDialogOpen = () => {
            this.setState({ open: true });
        };

        handleClose = () => {
            this.setState({ open: false });
        };


        clearTimeoutFunc = () => {
            if (this.warnTimeout) clearTimeout(this.warnTimeout);
            if (this.refreshTimeout) clearTimeout(this.refreshTimeout);
            if (this.durationInterval) clearInterval(this.durationInterval);
        };

        startCountDown = () => {
            let endTime = this.state.endTime;
            let currentTime = moment()
            let remaining = moment.duration(endTime.diff(currentTime));
            const interval = 1000;
            this.durationInterval = setInterval(function () {
                remaining = moment.duration(remaining - interval);
                this.setState({
                    duration: `${remaining.hours()} hour(s) : ${remaining.minutes()} minute(s) : ${remaining.seconds()} second(s)`
                });
            }.bind(this), interval);
        }

        setTimeout = () => {
            const now = moment();
            const durationTillWarn = this.state.warningTime.diff(now);
            const durationTillRefresh = this.state.endTime.diff(now);
            this.warnTimeout = setTimeout(this.warn, durationTillWarn);
            this.refreshTimeout = setTimeout(this.logout, durationTillRefresh);
            this.startCountDown();
        };

        resetTimeout = () => {
            this.handleClose();
            this.clearTimeoutFunc();
            this.getSessionTimeOut();
        };

        warn = () => {
            this.handleDialogOpen();
        };

        logout = () => {
            this.clearTimeoutFunc();
            this.destroy();
        };

        destroy = () => {
            window.location.href = "https://bciconline.com/report-claim/";
        };

        setSession = (idleTime, warningTime) => {
            const end = moment().add(idleTime, 'm');
            const warn = moment().add(warningTime, 'm');
            this.setState({
                endTime: end,
                warningTime: warn
            });
        }

        render() {

            return (
                <div>
                    <ComposedClass {...this.props} />
                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Session Inactive"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {`
                                You have been inactive for some time now. Your session will expire in 1
                                hour if you remain inactive.
                                `}
                                <br /><br />
                                <Typography gutterBottom variant="caption" align="center" color="error">
                                    Time remaining: {this.state.duration}
                                </Typography>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary" autoFocus>
                                Continue
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            );
        }
    }
}

export default withTimeOut;





// WEBPACK FOOTER //
// ./src/components/hoc/withTimeOut.js